import {useContext, useEffect} from 'react';
import {Context} from "../index";
import {useNavigate} from "react-router-dom";
import {AUTH_EXPIRED_EVENT, LOGIN_ROUTE} from "../util/Constants";
import {observer} from "mobx-react-lite";

/**
 * Реакция на истёкший/невалидный JWT: событие шлёт `$authHost` в `http/index.js`
 * (интерсептор на дефолтном axios не срабатывал для `$authHost`).
 */
const ErrorHandler = observer(({children}) => {
    const {user} = useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        const onSessionExpired = () => {
            user.logout();
            navigate(LOGIN_ROUTE, {replace: true});
        };
        window.addEventListener(AUTH_EXPIRED_EVENT, onSessionExpired);
        return () => window.removeEventListener(AUTH_EXPIRED_EVENT, onSessionExpired);
    }, [navigate, user]);

    return children;
});

export default ErrorHandler;
